export default function getImagePath(path) {
  return require(`../../assets/images/${path}`)
}
